export default __webpack_public_path__ + "73c3aa2dc0bc898b60110fc7f7b11f01.png";